function getTotalsHTML(label, expenses) {
    "use strict";

    return `<div class="cart-modal__subtotal">
        <span>${label}</span>
        <span>${expenses}</span>
    </div>`;
}

function renderTotals(expenses) {
    "use strict";

    var label = TYROOLA.translations['header-cart-subtotal'];
    return expenses ? getTotalsHTML(label, expenses) : '';
}

export default renderTotals;